<template>
    <b-card no-body bg-variant="dark" style="min-width: 300px;" class="mb-3">
        <b-card-header>
            <div v-if="devices.length">
                <b-input-group prepend="Choose a device:">
                    <b-form-select v-model="name">
                        <b-form-select-option
                            v-for="device in devices"
                            :key="device._id"
                            :value="device.name"
                        >
                            {{ device.nickname || device.name }}
                        </b-form-select-option>
                    </b-form-select>
                    <template v-slot:append>
                        <b-button variant="success" @click="load()">
                            Set up
                        </b-button>
                    </template>
                </b-input-group>
            </div>
            <div v-else>
                You have no devices. Go to the
                <b-link to="/dashboard" style="color: lightblue">
                    dashboard
                </b-link>
                to add one first.
            </div>
        </b-card-header>
        <b-card-body v-if="show">
            <b-card-group deck>
                <PeerCard
                    v-for="peer in peers"
                    :key="peer._id"
                    :id="peer._id"
                />
            </b-card-group>
        </b-card-body>
        <b-card-body v-if="loading">
            <Spinner text="Loading" />
        </b-card-body>
    </b-card>
</template>

<script>
    import { mapState } from 'vuex'
    import Spinner from '@/components/general/spinner'
    import PeerCard from './peer'

    export default {
        data() {
            return {
                name: '',
                loading: false,
                show: false
            }
        },
        methods: {
            load() {
                this.show = false
                this.loading = true
                return this.$store
                    .dispatch('user/peers/loadByDevice', this.name)
                    .then(() => {
                        this.show = true
                        this.loading = false
                    })
            }
        },
        created() {
            return this.$store.dispatch('user/devices/load')
        },
        computed: {
            peers() {
                return this.$store.getters['user/peers/getByDevice'](this.name)
            },
            ...mapState({
                devices: state => state.user.devices.devices
            })
        },
        components: {
            Spinner,
            PeerCard
        }
    }
</script>